import { renderRoutes } from 'react-router-config'
import { ROUTES } from './routes'

export const Pages = () => renderRoutes(ROUTES)
